module.exports = __webpack_public_path__ + "static/5-89a9e7c208d697665566ffd3f923dcce.jpg";